import type { GenworthPolicyDetails } from './policy-details-storage';

function money(value?: number) {
  return value === undefined
    ? undefined
    : value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: value % 1 === 0 ? 0 : 2,
      });
}

function formatInflation(details: GenworthPolicyDetails): string | undefined {
  if (details.inflationType === undefined) return undefined;
  if (details.inflationType === 'none') return 'None';

  const typeLabel = details.inflationType === 'compound' ? 'Compound' : 'Simple';

  return details.inflationRate !== undefined ? `${details.inflationRate}% ${typeLabel}` : typeLabel;
}

export interface PolicySummaryRow {
  label: string;
  value?: string;
}

export function getPolicySummaryRows(details: GenworthPolicyDetails): PolicySummaryRow[] {
  return [
    { label: 'Monthly premium', value: money(details.monthlyPremium) },
    { label: 'Original monthly premium', value: money(details.originalPremium) },
    { label: 'Total benefit pool', value: money(details.benefitPool) },
    { label: 'Daily benefit maximum', value: money(details.dailyBenefitMax) },
    { label: 'Monthly benefit maximum', value: money(details.monthlyBenefitMax) },
    { label: 'Inflation protection', value: formatInflation(details) },
    {
      label: 'Waiting period',
      value:
        details.waitingPeriodDays !== undefined ? `${details.waitingPeriodDays} days` : undefined,
    },
    {
      label: 'Partnership policy',
      value: details.isPartnership === undefined ? undefined : details.isPartnership ? 'Yes' : 'No',
    },
  ];
}
